import { defineStore } from "pinia";

export const useUndoRedoStore = defineStore("undo-redo", {
  state: () => ({
    undoQueue: {},
    redoQueue: {},
  }),
  actions: {
    canUndo(key) {
      return this.undoQueue[key]?.length > 0;
    },
    canRedo(key) {
      return this.redoQueue[key]?.length > 0;
    },
    addToUndoQueue(key, change) {
      if (!this.undoQueue[key]) {
        this.undoQueue[key] = [];
      }
      this.undoQueue[key].unshift(change);
    },
    addToRedoQueue(key, change) {
      if (!this.redoQueue[key]) {
        this.redoQueue[key] = [];
      }
      this.redoQueue[key].unshift(change);
    },
    undo(key) {
      return this.undoQueue[key].shift();
    },
    redo(key) {
      return this.redoQueue[key].shift();
    },
    clearUndoQueue(key) {
      this.undoQueue[key] = [];
    },
    clearRedoQueue(key) {
      this.redoQueue[key] = [];
    },
  },
});
